module.exports = __webpack_public_path__ + "static/media/okay.7629d2a9.svg";